var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpMobileBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52463 4.1969C7.78717 3.93437 8.21283 3.93437 8.47536 4.1969L15.8228 11.5443C16.0591 11.7806 16.0591 12.1637 15.8228 12.4C15.5865 12.6363 15.2034 12.6363 14.9671 12.4L8 5.43285L1.03287 12.4C0.796588 12.6363 0.413496 12.6363 0.177213 12.4C-0.0590709 12.1637 -0.0590709 11.7806 0.177213 11.5443L7.52463 4.1969Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpMobileBlue);
export default __webpack_public_path__ + "static/media/chevron_up_mobile_blue.33f8e1b5d1625ac94a4facd95efd782f.svg";
export { ForwardRef as ReactComponent };